import {
  post_request
} from '../axiosFun';

// 地图列表
export const get_map_list = (params) => {
  params = {
    row: {
      map_name: params.map_name_cn,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/map/get_list", params)
}
// 导入地图列表
export const get_import_list = (params) => {
  params = {
    row: {
      map_name: params.map_name_cn,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/map/get_import", params)
}
//导入地图信息
export const get_import_map_add = (params) => {
  params = {
    row: {
      map_ids: params,
    }
  }
  return post_request("/web/map/import_map", params)
};
//获取单条地图信息
export const get_one_map = (params,company_id) => {
  params = {
    row: {
      map_id: params,
      company_id:company_id
    }
  }
  return post_request("/web/map/get_one", params)
};
//修改地图信息
export const get_map_edit = (params) => {
    params = {
      row: {
        map_id: params.id,
        company_id:params.company_id,
        remark: params.remark || '',
      }
    }
    return post_request("/web/map/edit_remark", params)
  };
//修改状态
export const get_switch_status = (params,company_id ,status) => {
    params = {
      row: {
        map_id: params,
        company_id:company_id,
        status: status
      }
    }
    return post_request("/web/map/switch_status", params)
  };
  //删除地图
export const get_del_map = (params,company_id) => {
  params = {
    row: {
      map_id: params,
      company_id:company_id
    }
  }
  return post_request("/web/map/del_map", params)
};



// WEBPACK FOOTER //
// ./src/api/map_mn/map_mn.js